type BoxOfferRuleCardProps = {
  additonalClassName?: string
} & React.HTMLAttributes<HTMLDivElement>

export const BoxOfferRuleCard = ({ additonalClassName, children, ...props }: BoxOfferRuleCardProps) => {
  const defaultClassName = `
    flex align-items-center gap-2 h-7rem
    padding-card rounded-card
    ${additonalClassName ? additonalClassName : ""}
    `
  return (
    <div className={props.className ?? defaultClassName} {...props}>
      {children}
    </div>
  )
}
